var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6899 12.8921L23.9399 12.8921L23.9399 12.6421L23.9399 10.3632L23.9399 10.1132L23.6899 10.1132L7.17741 10.1132L12.0762 5.2145L12.2529 5.03772L12.0762 4.86094L10.4599 3.2447L10.2831 3.06792L10.1064 3.2447L2.02514 11.3259L1.84836 11.5027L2.02514 11.6795L10.1064 19.7607L10.2831 19.9375L10.4599 19.7607L12.0762 18.1445L12.2529 17.9677L12.0762 17.7909L7.17741 12.8921L23.6899 12.8921Z",
    fill: "#252636",
    stroke: "#252636",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionBackIcon);
export default __webpack_public_path__ + "static/media/collection-back-icon.f9ad590660c4ebbcb69b1171e1eb2dde.svg";
export { ForwardRef as ReactComponent };